module.exports = __webpack_public_path__ + "71d223ee3a985c09bd097db7faf742dd.pdf";